<template>
    <div class="animated fadeIn h-100">
        <b-row class="pt-4 px-4 pb-0">
            <b-col md="3" sm="12">
                <b-list-group style="overflow: auto;" class="contentInfo">
                    <b-list-group-item v-for="(item, index) in listData" :key="index" :active="item === selectData"
                        @click="selectData = item" href="#">
                        {{ `${index + 1}. ${item.name}` }}
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col md="9" sm="12">
                <b-card style="overflow: auto;" class="p-4 contentRight">
                    <pdfvuer v-if="pdfdata" :src="pdfdata" :key="selectData.id" :id="page" :page="page" :resize="true"
                        style="width:100%;margin: auto;">
                        <template slot="loading"> Đang tải dữ liệu </template>
                    </pdfvuer>
                </b-card>
                <div class="text-center mt-2">
                    <b-button class="mr-2" variant="primary" :disabled="!page || page == 1" @click="handleBack">
                        Trang trước
                    </b-button>
                    <span class="mr-2">{{ page }} / {{ numPages }}</span>
                    <b-button variant="primary" :disabled="page == numPages" @click="handleNext">
                        Trang sau
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import pdfvuer from 'pdfvuer';
import API_CONFIG from '@/api-config';

export default {
    components: {
        pdfvuer
    },
    async mounted() {
        await this.$nextTick();
        this.listData = await this.getList();
        if (this.listData.length > 0) this.selectData = this.listData[0];
    },
    data: function () {
        return {
            listData: [],
            selectData: null,
            page: 1,
            numPages: 0,
            pdfdata: null
        };
    },
    watch: {
        async selectData(val) {
            this.getPdf(val);
        }
    },
    methods: {
        ...mapActions({
            getList: 'tool/getList'
        }),
        getPdf(item) {
            this.page = 1;
            const url = API_CONFIG.BASE_URL + `download?fileName=${item.path}`;
            this.pdfdata = pdfvuer.createLoadingTask(url);
            this.pdfdata.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        handleBack() {
            this.page -= 1;
        },
        handleNext() {
            this.page += 1;
        }
    }
};
</script>
<style scoped>
.contentInfo {
    height: calc(100vh - 120px);
}

.contentRight {
    height: calc(100vh - 170px);
}
</style>
